webpackJsonp([148728742654319],{

/***/ 1513:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PriceTierInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"tier","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"unitFee","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-price-tier-input-3611265ca8118e930e74.js